import type { ApplicationDraft, AssessmentResult } from "../types/assessment";
export const demoApplication: ApplicationDraft = {
  id: "11111111-1111-4111-8111-111111111111",
  registrationType: "low_volume_mixed",
  usesDba: true,
  legalBusinessName: "Northstar Home Services LLC",
  brandName: "Northstar Home Services",
  businessType: "LLC",
  industry: "Home Services",
  state: "Colorado",
  country: "United States",
  websiteUrl: "https://example.com",
  optInUrl: "https://example.com/book",
  privacyPolicyUrl: "https://example.com/privacy",
  termsUrl: "https://example.com/terms",
  campaignUseCase: "Customer scheduling and service updates",
  campaignDescription:
    "Customers opt in on our booking form to receive appointment confirmations, reminders, and requested service updates from Northstar Home Services.",
  messageCategories: ["Appointment Reminders", "Customer Care"],
  estimatedMessageFrequency: "Up to 4 messages per month",
  containsLinks: true,
  containsPhoneNumbers: false,
  ageGatedContent: false,
  optInMethod: "Website Form",
  optInDiscovery:
    "Customers reach the booking form from the main website navigation.",
  optInSteps:
    "Choose a service, enter contact details, review the SMS disclosure, and select the optional checkbox.",
  phoneCollectionDescription:
    "A labeled mobile phone field on the booking form.",
  consentCollectionDescription:
    "An unchecked checkbox with separate SMS consent language.",
  postConsentDescription:
    "A confirmation page and opt-in confirmation message are shown.",
  consentOptionality: "Optional and not a condition of purchase.",
  marketingConsent:
    "By checking this box, you agree to receive recurring marketing text messages from [Brand Name]. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. View our Privacy Policy and Terms.",
  transactionalConsent:
    "By checking this box, you agree to receive service-related text messages from [Brand Name], including appointment reminders and account notifications. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help.",
  registrationInformationConfirmed: true,
  status: "changes_required",
  updatedAt: "2026-08-07T08:30:00Z",
  messages: {
    sample1:
      "Hi [First Name], this is [Brand Name]. Your appointment is confirmed for [Appointment Date] at [Appointment Time]. Reply STOP to opt out or HELP for assistance.",
    sample2: "Hi Sarah, your technician is on the way. Reply STOP to opt out.",
    sample3:
      "[Brand Name]: Your requested service update is ready at [Website URL]. Reply STOP to opt out or HELP for help.",
    confirmation:
      "You are subscribed to messages from [Brand Name]. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out or HELP for help.",
    stop: "You have been unsubscribed from [Brand Name] messages. No further messages will be sent.",
    help: "[Brand Name]: For help, call [Support Phone Number] or visit [Website URL]. Reply STOP to opt out.",
  },
};
const categories = [
  "Business Information",
  "Website",
  "Branding Consistency",
  "Privacy Policy",
  "Terms of Service",
  "Opt-In Form",
  "Consent Language",
  "Campaign Description",
  "Message Flow",
  "Sample Messages",
  "STOP / HELP",
  "Evidence",
];
export const mockAssessment: AssessmentResult = {
  assessmentId: "22222222-2222-4222-8222-222222222222",
  applicationId: demoApplication.id,
  status: "changes_required",
  score: 82,
  assessmentVersion: "1.0",
  rulesVersion: "DEMO-2026-08",
  documentationVersion: "DEMO-2026-08",
  aiModel: null,
  assessmentStartedAt: "2026-08-07T08:31:00Z",
  assessmentCompletedAt: "2026-08-07T08:32:12Z",
  templateVersions: [
    {
      templateId: "33333333-3333-4333-8333-333333333333",
      templateName: "Sample Appointment Message — DEMO",
      version: "2.0-demo",
      source: "internal",
    },
  ],
  categories: categories.map((label, index) => ({
    id: `category-${index}`,
    label,
    score: index === 9 ? 58 : index === 6 ? 76 : 94,
    severity: index === 9 ? "high" : index === 6 ? "medium" : "passed",
    summary:
      index === 9
        ? "One reusable message contains a customer-specific value."
        : index === 6
          ? "One disclosure can be clearer."
          : "No material issue detected in this simulation.",
  })),
  issues: [
    {
      id: "44444444-4444-4444-8444-444444444444",
      category: "Sample Messages",
      severity: "high",
      title: "Customer-specific value used instead of placeholder",
      currentContent:
        "Hi Sarah, your technician is on the way. Reply STOP to opt out.",
      problem:
        "A real-looking customer name appears in a reusable sample message.",
      reason:
        "Sample messages should represent reusable templates and clearly show variable fields.",
      recommendedReplacement:
        "Hi [First Name], your technician from [Brand Name] is on the way. Reply STOP to opt out or HELP for assistance.",
      possibleRejectionReason:
        "Sample-message content may not clearly represent reusable campaign messaging.",
      templateId: "33333333-3333-4333-8333-333333333333",
      templateName: "Sample Appointment Message — DEMO",
      templateVersion: "2.0-demo",
      documentationSource: "Internal Template — DEMO / PLACEHOLDER DATA",
      documentationUrl: null,
      confidence: 0.96,
    },
  ],
};
